import { Injectable } from '@angular/core';
import {NavService} from './nav-service';
import {Router} from '@angular/router';
import {EparcoursPath} from '../../constantes/menu/menu-items/eparcours-path';
import {PARAM_TOKEN} from './navigators/navigators';

@Injectable({
  providedIn: 'root',
})
export class AccueilNavService extends NavService {

  constructor(router: Router) {
    super(router)
  }

  dashboard = this.makeNavigator(
    EparcoursPath.root.ACCUEIL
  )

  saisie_absences = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.ACCUEIL,
    EparcoursPath.seances.SAISIE_ABSENCES,
    PARAM_TOKEN
  )

}
